<template>
    <tr with.bind="physician">
        <td>
            <EmptyTextHandler :text="physician.FirstName" />
        </td>
        <td>
            <EmptyTextHandler :text="physician.LastName" />
        </td>
        <td>
            <EmptyTextHandler :text="physician.WorkPhone" />
        </td>
        <td>
            <EmptyTextHandler :text="physician.FaxNumber" />
        </td>
        <td>
            <EmptyTextHandler :text="physician.Email" />
        </td>
        <td>
            <EmptyTextHandler :text="physician.SpecialtyName" />
        </td>
        <td>
            <a type="button" class="text-decoration-none" @click="deletePhysician(physician.Id)">Delete</a>
            <a
                v-if="!physician.IsPrimary"
                type="button"
                class="action-link text-decoration-none"
                @click="makePrimary(physician.Id)"
            >
                Make Primary
            </a>
            <a
                type="button"
                v-if="!physician.IsReferral"
                class="action-link text-decoration-none"
                @click="makeReferral(physician.Id)"
            >
                Make Referral
            </a>
        </td>
    </tr>
</template>

<script lang="ts" src="./EditPhysicianRow.ts"></script>
